"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.resultMessages = exports.Result = void 0;
const schema_1 = require("../../../schema");
var Result;
(function (Result) {
    Result["ABNORMAL"] = "ABNORMAL";
    Result["NORMAL"] = "NORMAL";
})(Result || (exports.Result = Result = {}));
exports.resultMessages = {
    [Result.ABNORMAL]: {
        id: "htx.screeningProcedures.chestXRay.result.ABNORMAL",
        defaultMessage: "Igen"
    },
    [Result.NORMAL]: {
        id: "htx.screeningProcedures.chestXRay.result.NORMAL",
        defaultMessage: "Nem"
    }
};
const result = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Result.ABNORMAL),
    schema_1.Schema.singleChoiceItem(Result.NORMAL)
])
    .expiration(15552000)
    .interpretation({ vocab: "htx", code: "chest_x_ray_result" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ result })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "399208008" })
    .tag({ vocab: "loinc", code: "36572-6" });
